export default "__VITE_ASSET__gLX5avlq__"